import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges } from '@angular/core';

import {
  getBackground,
  makeFontStyles,
  makeFontStyleStyles,
  makeLabelHorizontalAlignStyles,
} from '@blaze-shared/elements-domain';

import { CanvasElementBaseComponent } from '../__base/base.component';

// TODO: test
@Component({
  selector: 'be-payment-button',
  templateUrl: './payment-button.component.html',
  styleUrls: ['./payment-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentButtonComponent
  extends CanvasElementBaseComponent<'paymentButton'>
  implements OnChanges
{
  label!: string;
  icon!: string;
  buttonStyles!: Record<string, string>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['props']) {
      this.label = this.props?.content?.button?.label || '';
      this.icon = this.props?.content?.button?.icon || '';
      this.updateStyles();
    }
  }

  emitClick(toolbarTriggered = false): void {
    if (!this.isInEditor || toolbarTriggered) {
      this.output.emit({
        eventType: 'click',
        schema: null,
        data: undefined,
        isInitialData: false,
      });
    }
  }

  private updateStyles(): void {
    const { style, content } = this.props || {};
    const { button, font, label } = style || {};
    if (!style || !button || !font || !label) {
      return;
    }

    const buttonStyles: Record<string, string> = {
      color: label.color.color1,
      background: getBackground(button.fill),
      ...makeFontStyles(font),
      ...makeFontStyleStyles(font?.style, '700'),
      ...makeLabelHorizontalAlignStyles(label?.align || 'center'),
      ['font-weight']: this.fontsService.getFontWeight(font.fontFamily, font.fontWeight),
    };
    if (content?.button?.iconPosition === 'right') {
      buttonStyles['flex-direction'] = `row-reverse`;
    }
    if (button.outline.selectorType !== 'none') {
      buttonStyles['border'] = `1px solid ${button.outline.color1}`;
    }
    if (button.radius !== '0px') {
      buttonStyles['border-radius'] = button.radius;
    }

    this.buttonStyles = buttonStyles;
  }
}
